import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { SearchRequest } from '../Models/SearchRequest';
import { SearchResult } from '../Models/SearchResult';
import { Equipment } from '../Models/Equipment';

class SearchApi {
  static search(data: SearchRequest) {
    return axios.post<SearchResult[]>(
      `${API_URL}/api/search`,
      data,
      getAuthHeader()
    );
  }
  static searchBasic(filters: object) {
    return axios.post<Equipment[]>(
      `${API_URL}/api/search/SearchBasic`,
      filters,
      getAuthHeader()
    );
  }
  static manufacturerSearch(data: SearchRequest, id: string) {
    return axios.post<SearchResult[]>(
      `${API_URL}/api/search/manufacturer/${id}`,
      data,
      getAuthHeader()
    );
  }
}

export default SearchApi;
